import BezierCurve from './bezier'

function registerScroll(fn) {
    if(window.attachEvent) {
        window.attachEvent('onscroll', fn);
    }else if(window.addEventListener) {
        window.addEventListener('scroll', fn);
    }else {
        window.onscroll = fn;
    }
}

function removeScroll(fn) {
    if(window.removeEvent) {
        window.removeEvent('onscroll', fn);
    }else if(window.removeEventListener) {
        window.removeEventListener('scroll', fn);
    }else {
        window.onscroll = null;
    }
}

class BaseDom {
    getZoom(dom) {
        if(!dom) dom = document.body;

        var zoom = dom.style.zoom;

        if(zoom == '') return 1;

        return parseFloat(zoom);
    }
    getScrollTop() {
        return parseInt(document.documentElement.scrollTop||document.body.scrollTop);
    }
    getScrollBottom() {
        return parseInt(this.getScrollTop() + window.innerHeight);
    }
}
/**
 * 兼容zoom
 */
class ZoomedDom extends BaseDom { 
    constructor(dom, offsetDom) { 
        super();

        this.dom = dom;
        this.offsetDom = offsetDom;
    }
    getOriginOffsetTop() { 
        var dom = this.dom;
        var top = 0;

        while(dom) { 
            if(dom == document.body) break;

            if(!dom.previousElementSibling) {
                dom = dom.offsetParent;
                continue;
            }else if(dom.offsetTop <= dom.previousElementSibling.offsetTop){
                //防止遇到绝对定位
                dom = dom.previousElementSibling;
                continue;
            }else{
                dom = dom.previousElementSibling;
            }
            
            top += dom.clientHeight * this.getZoom(dom);
        }

        return parseInt(top);
    }
    getOffsetTop() { 
        return parseInt(this.getOriginOffsetTop() * this.getZoom()); 
    }
    getOffsetBottom() { 
        var res = null;

        if(!this.dom.offsetParent)
            res = this.dom.offsetHeight;
        else if(this.dom.offsetParent == document.body){
            res = (this.getOriginOffsetTop() + this.dom.offsetHeight) * this.getZoom();
        }else{
            res = (this.getOriginOffsetTop() + this.dom.offsetHeight * this.getZoom(this.dom.offsetParent)) * this.getZoom();
        }

        return parseInt(res);
    }
}

ZoomedDom.createList = function(doms, offsetDom) { 
    var list = [];
    for(var index in doms) { 
        if(doms.hasOwnProperty(index))
            list.push(new ZoomedDom(doms[index], offsetDom))
    }

    list.sort((a,b)=>{
        return a.getOffsetTop() - b.getOffsetTop();
    })

    return list;
}
/**
 * 
 */
class ScrollNotify { 
    /**
     * scrollTo 
     * @param {*} config 
     * 所有zoom的位置都调整到未zoom的位置 
     */
    constructor(config) { 
        this.onenter = config.onenter;

        this.baseDom = new BaseDom(); 

        this.showList = { 
            /**
             * 需要监听显示事件的元素
             */
            list: ZoomedDom.createList(config.doms, config.offsetDom),
            /**
             * 
             */
            from: 0,
            /**
             * 屏幕中显示的最后面的指定元素索引
             */
            to: -1,
            /**
             * 屏幕中显示的元素（从上到下排列）
             */
            shows: [],
            length: 0,
            get(index) {
                return this.list[index];
            },
            removeFrom() {
                if(this.from === this.to) {
                    if(this.shows.length > 0) {
                        return this.shows.shift();

                    }else return null;
                }else {
                    this.from++;
                    return this.shows.shift();
                }
            },
            removeTo() {
                if(this.from === this.to) {
                    if(this.shows.length > 0) {
                        return this.shows.pop();

                    }else return null;
                }else {
                    this.to--;
                    return this.shows.pop();
                }
            },
            addFrom() {
                if(this.from === 0) return null;

                this.from--;
                this.shows.unshift(this.get(this.from))

                return this.get(this.from);
            },
            addTo() {
                if(this.to === this.list.length - 1) return null;

                this.to++;
                this.shows.push(this.get(this.to));

                return this.get(this.to);
            },
            getTo(){
                if(this.shows.length == 0) return null;

                return this.get(this.to);
            },
            getFrom(){
                if(this.shows.length == 0) return null;

                return this.get(this.from);
            },
            getFromPrev(){
                if(this.from == 0) return null;

                return this.get(this.from - 1);
            },
            getToNext(){
                if(this.to == this.list.length - 1) return null;

                return this.get(this.to + 1);
            },
            ifEmpty(){
                return this.length == 0;
            }
        }

        this.init(); 
    }
    EVENTS = {
        ONENTER:'onenter',
        ONLEAVE:'onleave'
    }
    /**
     * 初始化为当前高度
     */
    init() {
        this.calcCurrent();

        if(this.showList.list[0].getOffsetTop() > this.currentBottom){
            return;
        }

        //第一个元素直接onenter
        this.dispatch(this.EVENTS.ONENTER, true);
        //不移动
        this.showList.removeTo();

        this.scrollToBottom();
    }
    calcCurrent() {
        this.currentTop = this.baseDom.getScrollTop();
        this.currentBottom = this.baseDom.getScrollBottom();
    }
    /**
     * 下一个元素在屏幕中
     */
    scrollNext() {
        var scrolled = false;
        
        while(true){
            var next = this.showList.getToNext();

            if(next == null) break;

            if(next.getOffsetTop() < this.currentBottom){
                scrolled = true;
                this.dispatch(this.EVENTS.ONENTER, true);
            }
            else break;
        }

        return scrolled;
    }
    /**
     * 上一个元素在屏幕中
     */
    scrollPrev() {
        var scrolled=  false;

        while(true) {
            var prev = this.showList.getFromPrev();

            if(prev == null) break;

            if(prev.getOffsetBottom() > this.currentTop) { 
                scrolled = true;
                this.dispatch(this.EVENTS.ONENTER, false);
            }
            else break;
        }

        return scrolled;
    }
    /**
     * 当前最后面的元素消失在屏幕外
     */
    removeNext() {
        while(true) {
            var last = this.showList.getTo();

            if(last == null) break;

            if(last.getOffsetTop() > this.currentBottom)
                this.dispatch(this.EVENTS.ONLEAVE, false);
            else break;
        }
    }
    /**
     * 当前最前面的元素消失在屏幕外
     */
    removePrev() {
        while(true) {
            var prev = this.showList.getFrom();

            if(prev == null) break;

            var offsetBottom = prev.getOffsetBottom();

            if(offsetBottom < this.currentTop)
                this.dispatch(this.EVENTS.ONLEAVE, true);
            else break;
        }
    }
    dispatch(name, down) {
        var ele = null;

        switch(name) {
            default:
            return;
            case this.EVENTS.ONENTER:
                if(down) {
                    ele = this.showList.addTo();
                    console.log('enter down ==> '+ ele);
                }else {
                    ele = this.showList.addFrom();
                    console.log('enter up ==> '+ ele);
                }
            break;
            case this.EVENTS.ONLEAVE:
                if(down) {
                    ele = this.showList.removeFrom();
                    console.log('leave down ==> '+ ele);
                }else {
                    ele = this.showList.removeTo();
                    console.log('leave up ==> '+ ele);
                }
            break;
        }

        if(this[name] && ele)
            this[name]({
                ele,
                down
            });
    }
    onscroll() {
        var scrolledTop = this.baseDom.getScrollTop();

        if(this.currentTop == scrolledTop) return;
            //向上
        if(this.currentTop > scrolledTop) {
            this.calcCurrent();
            this.scrollToTop();
        }else {
            this.calcCurrent();
            //向下
            this.scrollToBottom();
        }
    }
    scrollToTop() {
        this.scrollPrev();
        this.removeNext();
    }
    scrollToBottom() {
        this.scrollNext();
        this.removePrev();
    }
    run() {
        var self = this;

        var fn = this.scrollFn = ()=> {
            self.onscroll();
        };

        registerScroll(fn);
    }
    stop() {
        removeScroll(this.scrollFn);
    }
}

function ScrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
}

export { 
    ScrollNotify,
    registerScroll,
    removeScroll,
    ScrollToTop
};



// WEBPACK FOOTER //
// ./src/api/scroll.js


// WEBPACK FOOTER //
// ./src/api/scroll.js